import React, {Component, Children, cloneElement} from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

class Tabs extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    activeTab: PropTypes.number,
    onTabTitleClick: PropTypes.func,
    type: PropTypes.oneOf(['flat']),
    branding: PropTypes.shape({
      tabItemWrapper: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      tabItem: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      tabHeader: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      tabContent: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      tabActive: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    })
  }

  static defaultProps = {

    // OnTabTitleClick prop can return {true} to proceed and update component's state rr return {false} to disable Tabs switching (this is FF workaround prevents us from relying on browser's event bubbling implementation)
    onTabTitleClick: () => true,
    branding: {
      tabItemWrapper: '',
      tabItem: '',
      tabHeader: '',
      tabContent: '',
      tabActive: ''
    },
    activeTab: null
  }

  constructor(props) {
    super(props)

    this.state = {activeTab: props.activeTab || 0}
  }

  componentDidUpdate = ({activeTab: prevActiveTab}) => {
    const {activeTab} = this.props

    if (Number.isFinite(activeTab) && activeTab !== prevActiveTab) {
      this.setState({activeTab})
    }
  }

  onTabTitleClick = index => {
    const {onTabTitleClick, onTabClick} = this.props

    if (onTabTitleClick()) {
      this.setState({activeTab: index})
    }

    onTabClick && onTabClick(index)
  }

  getTitles = () => {
    const {children, branding} = this.props,
      {activeTab} = this.state,
      tabItemClassName = this.getClassName('tabItem'),
      tabItemWrapperClassName = this.getClassName('tabItemWrapper')

    return Children.map(children, (tab, index) =>
      <div
        className={`
          ${branding.tabItemWrapper} ${activeTab === index ? branding.tabActive : ''}
          ${tabItemWrapperClassName} ${activeTab === index ? styles.active : ''}
        `}
      >
        <button
          className={`${branding.tabItem} ${tabItemClassName}`}
          onClick={() => this.onTabTitleClick(index)}
        >
          {tab.props.title}
        </button>
      </div>
    )
  }

  getContent = () => cloneElement(
    this.props.children[this.state.activeTab],
    {key: this.state.activeTab},
  )

  getClassName = className => {
    const {type} = this.props

    return `${styles[`${className}${type ? type[0].toUpperCase() + type.slice(1) : ''}`]}`
  }

  render() {
    const {branding} = this.props
    const tabHeaderClassName = this.getClassName('tabHeader')

    return (
      <div>
        <div className={`${branding.tabHeader} ${tabHeaderClassName}`}>
          {this.getTitles()}
        </div>
        <div className={`mt-24 ${branding.tabContent}`}>
          {this.getContent()}
        </div>
      </div>
    )
  }
}

export default Tabs
